module.exports = __webpack_public_path__ + "static/Cel1portugues-b0ca1e5114957e684b9544fb78414f1f.mp4";